import { fromJS } from 'immutable';

export const I18N_CHANGE_LANGUAGE_INIT = 'i18n/CHANGE_LANGUAGE_INIT';
export const I18N_CHANGE_LANGUAGE_SUCCESS = 'i18n/CHANGE_LANGUAGE_SUCCESS';
export const I18N_CHANGE_LANGUAGE_FAILED = 'i18n/CHANGE_LANGUAGE_FAILED';

const options = new Map();
const LOCALES = new Map();

function getLocale(lang) {
  return {
    lang,
    locale: LOCALES.get(lang) || {}
  };
}

export function changeLanguage({ lang, locale = LOCALES.get(lang) }) {
  if (!locale) {
    if (options.get('async')) {
      return {
        types: [
          I18N_CHANGE_LANGUAGE_INIT,
          I18N_CHANGE_LANGUAGE_SUCCESS,
          I18N_CHANGE_LANGUAGE_FAILED
        ],
        promise: client =>
          client
            .get(options.get('async').replace('%s', lang))
            .then(locale => ({ lang, locale }))
      };
    }

    return {
      type: I18N_CHANGE_LANGUAGE_FAILED
    };
  }

  return {
    type: I18N_CHANGE_LANGUAGE_SUCCESS,
    payload: { lang, locale }
  };
}

export function serialize(state) {
  return state.lang;
}

export function deserialize(state) {
  return getLocale(state);
}

export default function createReducer({
  locales = {},
  onChange,
  async,
  defaultLanguage: lang
} = {}) {
  if (async) {
    options.set('async', async);
  }

  const onChangeHook = typeof onChange === 'function';

  Object.keys(locales).forEach(key => {
    LOCALES.set(key, fromJS(locales[key]));
  });

  const initialState = getLocale(lang);

  return function i18nReducer(state = initialState, action) {
    if (action.type === I18N_CHANGE_LANGUAGE_SUCCESS) {
      if (onChangeHook) {
        onChange(action.payload.lang);
      }
      return action.payload;
    }

    return state;
  };
}
